import { ReactNode } from "react";
import {
  IconFolder,
  IconFolderOpen,
  IconChevronRight,
  IconChevronDown,
} from "@tabler/icons-react";

export interface ItemNoun {
  singular: string;
  plural: string;
}

interface MonthFolderProps<T> {
  monthName: string;
  items: T[];
  isExpanded: boolean;
  onToggle: () => void;
  getDate: (item: T) => string | Date;
  getItemKey: (item: T) => string | number;
  renderItem: (item: T) => ReactNode;
  itemNoun: ItemNoun;
}

export function MonthFolder<T>({
  monthName,
  items,
  isExpanded,
  onToggle,
  getDate,
  getItemKey,
  renderItem,
  itemNoun,
}: MonthFolderProps<T>) {
  const sortedItems = [...items].sort(
    (a, b) => new Date(getDate(b)).getTime() - new Date(getDate(a)).getTime(),
  );

  const noun = items.length === 1 ? itemNoun.singular : itemNoun.plural;

  return (
    <div className="select-none">
      <button
        onClick={onToggle}
        className="flex items-center gap-2 w-full p-2 rounded-lg hover:bg-slate-50 transition-colors text-left group"
      >
        <span className="text-slate-400 transition-transform duration-200">
          {isExpanded ? (
            <IconChevronDown size={16} />
          ) : (
            <IconChevronRight size={16} />
          )}
        </span>
        <span className="text-blue-500">
          {isExpanded ? (
            <IconFolderOpen size={20} />
          ) : (
            <IconFolder size={20} />
          )}
        </span>
        <span className="font-medium text-gray-700">{monthName}</span>
        <span className="text-gray-400 text-sm ml-auto">
          {items.length} {noun}
        </span>
      </button>

      {isExpanded && (
        <div className="ml-6 border-l-2 border-slate-100 pl-2 mt-1 space-y-1">
          {sortedItems.map((item) => (
            <div key={getItemKey(item)}>{renderItem(item)}</div>
          ))}
        </div>
      )}
    </div>
  );
}
